import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { characters } from "@/mocks/people";

export default function Cast() {
  return (
    <section id="cast" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Characters"
              title="主要人物：每个人都在推动故事往前走"
              desc="影片的人物并不只是陪衬。主角的每一次转变，几乎都由身边的人触发。下面按重要程度排列，说明他们在故事里承担什么作用。"
            />
          </Reveal>

          <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {characters.map((person, index) => (
              <Reveal key={person.id} delay={index * 60}>
                <article className="group h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                  <div className="relative w-full h-72 md:h-80 overflow-hidden">
                    <img
                      src={person.image}
                      alt={`${person.name}（${person.actor}）剧照氛围图`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent" />
                    <div className="absolute left-0 right-0 bottom-0 p-5">
                      <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">
                        {person.name}
                      </h3>
                      <p className="mt-1 font-label text-xs md:text-sm text-accent-300">
                        {person.actor}
                      </p>
                    </div>
                  </div>
                  <div className="p-5 md:p-6">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label text-xs">
                      <i className="ri-link" />
                      {person.role}
                    </span>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                      {person.desc}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}